import React from "react";
import "./forLawyers.css";
import { useNavigate } from "react-router-dom";
const PracticeSolutions = () => {
  const navigate = useNavigate();
  const items = [
    {
      title: "Website Appointment Scheduling",
      description:
        "Allow clients to book appointments directly through your website, 24/7.",
      price: "Free",
    },
    {
      title: "Search Engine Booking",
      description:
        "Enable clients to schedule appointments via Google, Apple, Bing, and more.",
      price: "Free",
    },
    {
      title: "Retainer Agreements",
      description: "Fees are based on services provided by your firm.",
      price: "Custom",
    },
    {
      title: "Platform Service Fees",
      description:
        "A one-time fee applies for clients acquired through our platform.",
      price: "One Time Fee",
    },
  ];

  return (
    <div className="table-section">
      <p className="lawyer-hero-heading">Get Started Today!</p>
      <p variant="body2" className="card-description">
        No upfront fees or subscription costs.
      </p>
      <div className="table-container">
        {/* Title */}
        <h1 className="table-title">Quidpro.Ai Practice Solutions</h1>
        <hr />
        {/* List Items */}
        <div className="table">
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <div className="row">
                <div className="row-content">
                  <h3 className="row-title">{item.title}</h3>
                  <p className="row-description">{item.description}</p>
                </div>
                <div className="row-price">{item.price}</div>
              </div>
              <hr />
            </React.Fragment>
          ))}
        </div>

        {/* CTA Button */}
        <div className="cta-container">
          <button
            className="cta-button"
            onClick={() => navigate("/grow/sign-up")}
          >
            Register your Firm Today
          </button>
        </div>
      </div>
    </div>
  );
};

export default PracticeSolutions;
